<template lang="pug">
  .pos-list(v-if='posData')
    .pos-item(v-for='pos in orderedPosList' :key='pos.Id' :class="{'is-active': (selectedRestaurant && (pos.Id === selectedRestaurant.pos.Id))}" @click.prevent="$emit('change',pos,location)")
      div.pos-item__inner
        p
          span.pos-name.color-brand {{pos.Pos_Name}}
          span.pos-dist {{ pos.Distance > 0 ? (pos.Distance + 'km'): pos.Distance }}
        p
          span.post-address {{ pos.Pos_Address }}
      svg(class="pos-item__arrow" width='19' height='17' viewbox='0 0 19 17' fill='none' xmlns='http://www.w3.org/2000/svg')
        path(d='M10.7045 1.28395C10.3111 0.896331 9.678 0.901021 9.2904 1.29443C8.9027 1.68783 8.9074 2.32098 9.3008 2.7086L14.6712 8H1C0.44771 8 0 8.4477 0 9C0 9.5523 0.44772 10 1 10H14.6646L9.3008 15.2849C8.9074 15.6725 8.9027 16.3057 9.2904 16.6991C9.678 17.0925 10.3111 17.0972 10.7045 16.7095L17.6287 9.8871C18.1256 9.3975 18.1256 8.5959 17.6287 8.1063L10.7045 1.28395Z' fill='#ADA8A8')

</template>
<script>
  import _ from 'lodash';
  import {mapState} from 'vuex'
  export default {
    name: 'PosList',
    props: {
      posData: Array,
      location: Object,
    },
    created () {

      this.parseDistances()

    },
    watch: {
      location () {
        this.parseDistances()
      }
    },
    data () {
      return {
        dis: -1,
      }
    },
    methods: {
      setPos(pos) {
      },
      async parseDistances() {
        if (this.posData) {
          for (let index = 0; index < this.posData.length; index++) {
            const item = this.posData[index]

            if (this.location) {

              this.$set(this.posData[index],'Distance', 'loading ...')
            } else {
              this.$set(this.posData[index],'Distance', '')
            }

            const aNew = await this.getDistance(item, this.location)
            //console.log(aNew)
            if (aNew && aNew.data && aNew.data.distance > 0) {
              this.$set(this.posData[index],'Distance', aNew.data.distance)
            }
          }
        }
      },
      getDistance(pos, location, amount = 50000) {
        if (pos && pos.Id && location && location.lng && location.lat) {
          return this.$http.get(this.$foodbookConfig.wpapi + '/ship', {
            params: {
              pos_id: pos.Id,
              pos_parent: 'SUONMUOI',
              lng: location.lng,
              lat: location.lat,
              amount: amount
            }
          }).then(({data}) => data);
        } else {
          return -1; // Không xác định
        }

      },
      checkDistance(pos, location, amount = 50000) {
        if (pos && pos.Id && pos.Pos_Parent && location && location.lng && location.lat) {
          return this.$http.get(this.$foodbookConfig.wpapi + '/ship', {
            params: {
              pos_id: pos.Id,
              pos_parent: pos.Pos_Parent,
              lng: location.lng,
              lat: location.lat,
              amount: amount
            }
          }).then(({data}) => {
            // Trả về khoảng cách
            return (data && data.data && data.data.distance) ? data.data.distance : -1;
          });
        } else {
          return -1; // Không xác định
        }

      },
    },
    computed: {
      ...mapState({
        selectedRestaurant: state => state.restaurants.selectedRestaurant,
      }),
      orderedPosList() {
        return this.posData
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/HeaderPosList.vue